module.exports = __webpack_public_path__ + "media/images/location--valderrama-49ef7885c13021ba3c51e4d668747c28.jpg";